<template>
    <router-view>
      <router-view />
      <notifications group="foo" />
    </router-view>
</template>
<script>
export default {
  name: 'App',
  mounted() {
    const script = document.createElement('script');
    script.src = 'https://d7nzzuxaahac2.cloudfront.net/web/chat.js';
    script.id = '9hqw3Hr3pKJ967gSeDP8';
    document.body.appendChild(script);
  },
}
</script>

<style>
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
</style>
